<div class="row mb-2">
  <label class="col-sm-6" translate>Icon size</label>
  <div class="col-sm-6">
    <select type="text" class="form-select form-select-sm" [(ngModel)]="component.element.icon_size">
      <option value="16px">16px</option>
      <option value="24px">24px</option>
      <option value="32px">32px</option>
      <option value="48px">48px</option>
      <option value="64px">64px</option>
    </select>
  </div>
</div>
<div class="social-item mb-3 p-3 bg-light" *ngFor="let social of component.buttons">
  <div class="row g-0">
    <div class="col-sm-10">
      <div ngbDropdown class="d-block">
        <button class="btn btn-sm w-100 btn-outline-primary" ngbDropdownToggle>
          <i [class]="social.icon"></i>
          {{ social.name }}
        </button>
        <div ngbDropdownMenu>
          <a
            ngbDropdownItem
            *ngFor="let socialNetwork of socialNetworks"
            (click)="setButton(social, socialNetwork)"
            class="social-item-wrapper"
          >
            <div class="row">
              <div class="col-sm-2">
                <i [class]="socialNetwork.icon"></i>
              </div>
              <div class="col-sm-10">
                {{ socialNetwork.name }}
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
    <div class="col-sm-2 text-end">
      <button class="btn btn-sm btn-danger" (click)="deleteButton(social.id)" [disabled]="component.buttons.length === 1">
        <i class="fas fa-trash fa-fw"></i>
      </button>
    </div>
  </div>
  <div class="mt-2">
    <label class="mb-1" translate>Link</label>
    <input type="text" class="form-control form-control-sm" [(ngModel)]="social.link_to" />
  </div>
</div>
<button class="btn btn-link btn-sm mb-3" (click)="addButton()">
  <i class="fas fa-plus me-2"></i>
  <span translate>Add the button</span>
</button>
<div class="row mb-2">
  <label class="col-sm-12 mb-1" translate>Placement</label>
  <div class="col-6">
    <select class="form-select form-select-sm" [(ngModel)]="component.element.placement">
      <option value="vertically">Vertically</option>
      <option value="horizontally">Horizontally</option>
    </select>
  </div>
  <div class="col-6">
    <div class="row g-0">
      <button
        class="col btn btn-primary btn-sm rounded-0"
        [ngClass]="{ active: component.element.alignment === 'left' }"
        (click)="component.element.alignment = 'left'"
      >
        <i class="fas fa-align-left"></i>
      </button>
      <button
        class="col btn btn-primary btn-sm rounded-0"
        [ngClass]="{ active: component.element.alignment === 'center' }"
        (click)="component.element.alignment = 'center'"
      >
        <i class="fas fa-align-center"></i>
      </button>
      <button
        class="col btn btn-primary btn-sm rounded-0"
        [ngClass]="{ active: component.element.alignment === 'right' }"
        (click)="component.element.alignment = 'right'"
      >
        <i class="fas fa-align-right"></i>
      </button>
    </div>
  </div>
</div>
